import { render } from "./AccordionExtratoPontos.vue?vue&type=template&id=ca1bacda"
import script from "./AccordionExtratoPontos.vue?vue&type=script&lang=js"
export * from "./AccordionExtratoPontos.vue?vue&type=script&lang=js"
script.render = render

export default script